export default {
  '抱歉，你访问的页面出错了。': 'Page Error.'
};
